<template>
	<div id="star" class="jon-slider">
		<h3 class="text-center mt-5" style="line-height: 1.5em"><b class="text-gradient">Star</b></h3>
		<p class="text-center font-courier text-gold">Repository anda yang paling disukai</p>
		<div>
			<div v-for="(s) in star" :key="s.name" class="my-3">
				<p class="h4"><a :href="'https//github.com/' + profil.name + '/' + s.name" class="text-white">{{s.name}}</a> <span class="badge text-gradient">{{s.data.length}}</span></p>
				<hr style="border-bottom:1px solid #333" />
				<div class="row">
					<div v-for="(d) in s.data" :key="d.id" class="col-sm-6 col-md-3 my-3" style="display: flex;">
						<div class="mr-3">
							<img :src="d.avatar_url" class="avatar" width="75" height="75">
						</div>
						<div>
							<p class="mb-0">{{d.login}}</p>
							<p><code>{{d.id}}</code></p>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div v-if="stat.star > 1" class="section-fade"></div>
		<div class="review-star">
			<div class="row">
				<div class="col-md-6">
					<p class="text-center">Jumlah Star Sampai Saat Ini</p>
					<CounterStyle identify="statstar" :value="stat.star" :key="5"></CounterStyle>
				</div>
				<div class="col-md-6">
					<p class="text-center">Jumlah Star Yang Ingin Anda Capai (2021)</p>
					<CounterStyle identify="resostar" :value="resolution.star" :key="6" :is_res="true"></CounterStyle>
				</div>
			</div>
			<ReviewBox :stat="stat.star" :reso="resolution.star" :progress="progress.star" identify="star" :key="3"></ReviewBox>
		</div>
	</div>
</template>

<script>
import CounterStyle from './../components/CounterStyle'
import ReviewBox from './../components/ReviewBox'
export default {
	data(){
		return {
			// number: []
		}
	},
	components: {
		CounterStyle, ReviewBox
	},
	props: ['stat', 'resolution', 'progress', 'star', 'profil'],
	methods: {

	},
	mounted(){

	}
}
</script>

<style>
	
</style>